import {
  ChatSupplier_SupplierEmployeesQuery,
  ChatSupplier_SupplierEmployeesQueryVariables,
} from '@/types';
import { gql } from '@apollo/client';
import { useMemo } from 'react';
import { useWrappedQuery } from './use-wrapped-query';

export const SUPPLIER_EMPLOYEES_QUERY = gql`
  query ChatSupplier_SupplierEmployees($chatUUID: uuid!) {
    chats_by_pk(uuid: $chatUUID) {
      supplier {
        businesses_employees {
          employee_uuid
          uuid
        }
        uuid
      }
      uuid
    }
  }
`;

export const useSupplierEmployees = (chatUUID: string) => {
  const { data, hasResponse } = useWrappedQuery<
    ChatSupplier_SupplierEmployeesQuery,
    ChatSupplier_SupplierEmployeesQueryVariables
  >(SUPPLIER_EMPLOYEES_QUERY, {
    variables: {
      chatUUID,
    },
  });

  const supplierEmployeeUUIDs = useMemo(() => {
    const supplierEmployees = data?.chats_by_pk?.supplier.businesses_employees;
    return (supplierEmployees || []).map((supplierEmployee) => {
      return supplierEmployee.employee_uuid;
    });
  }, [data]);

  return {
    hasResponse,
    supplierEmployeeUUIDs,
  };
};
